import numeral from "numeral";
import { formatAmount } from "./text.utils";

const normalizeNumericString = (value, suffix = "") => {
  if (value == null) {
    return "";
  }

  const suffixPattern = suffix ? new RegExp(`\\s*${suffix}$`) : null;
  const normalized = value
    .toString()
    .trim()
    .replace(/,/g, "")
    .replace(suffixPattern || /$/, "");

  return normalized;
};

const addThousandsSeparators = (value = "") => {
  return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const checkIfValidByDecimalPlaces = (value, decimalPlace) => {
  const regex = new RegExp(/[^0-9]/);
  const val = value.toString().split(".");

  if (val.length > 2) {
    return false;
  }

  if (!val[1]) {
    val.push("0");
  }

  if (val[1].length > decimalPlace) {
    return false;
  }

  return !regex.test(val[0]) && !regex.test(val[1]);
};

export const formatNumber = (num, decimalPlaces = 3) => {
  const normalized = normalizeNumericString(num);

  if (!normalized) {
    return `${Number(0).toLocaleString("en", {
      minimumFractionDigits: decimalPlaces,
      maximumFractionDigits: decimalPlaces,
    })}`;
  }

  const isNegative = normalized.startsWith("-");
  const unsignedValue = isNegative ? normalized.slice(1) : normalized;
  const [rawIntegerPart = "0", rawDecimalPart = ""] = unsignedValue.split(".");
  const integerPart = rawIntegerPart.replace(/^0+(?=\d)/, "") || "0";
  const decimalPart = rawDecimalPart.padEnd(decimalPlaces, "0").slice(0, decimalPlaces);
  const formattedInteger = addThousandsSeparators(integerPart);
  const sign = isNegative ? "-" : "";

  if (!decimalPlaces) {
    return `${sign}${formattedInteger}`;
  }

  return `${sign}${formattedInteger}.${decimalPart}`;
};

export const parseNumber = (num) => {
  return numeral(num).value();
};

export const unformatNumber = (num, suffix = "") => {
  return normalizeNumericString(num, suffix);
};

export const roundUp = (num) => {
  return Number(numeral(num).format("00.000"));
};

export const formatVolume = (num, suffix = "L") => {
  return `${formatNumber(num)} ${suffix}`;
};

export const parseLiter = (num) => {
  return parseNumber(num.toString().replace(" L", ""));
};

export const formatAmountPerLiter = (num) => {
  return `${formatAmount(num)} / L`;
};

export const formatCurrency = (num, prefix = "₱") => {
  return `${prefix} ${formatNumber(num, 2)}`;
};

export const formatBytes = (bytes, decimals) => {
  if (bytes === 0 || !bytes) return "0 Bytes";
  let k = 1024,
    dm = decimals || 2,
    sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
    i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};
